import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
  Title,
} from "chart.js";

// Register required components
ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
  Title
);

const LineChart = ({
  labels,
  datas,
  name,
  area,
  valueSign,
  isSmall = false,
}) => {
  const data = {
    labels: isSmall
      ? labels.map(
          (label) => `${label.slice(8, label.length)}-${label.slice(5, -3)}`
        )
      : labels.map(
          (label) =>
            `${label.slice(8, label.length)}-${label.slice(
              5,
              -3
            )}-${label.slice(0, 4)}`
        ),
    datasets: [
      {
        label: name,
        data: datas?.map(Number),
        borderColor: "#33D553",
        backgroundColor: "rgba(51, 213, 83, 0.2)",
        fill: true,
        tension: 0.3,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: "top",
        labels: {
          color: "#333", // color of legend text (not visible if legend is hidden)
          font: {
            size: 14,
          },
        },
      },
      title: {
        display: true,
        text: `${isSmall ? name : area}`,
        color: "#333", // title text color
        font: {
          size: 18,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        // max: 100,
        ticks: {
          color: "#333", // x-axis labels
          callback: (value) => `${value}`,
        },
        title: {
          display: !isSmall,
          color: "#333", // x-axis title
          text: `${name} ${valueSign}`,
        },
      },
      x: {
        ticks: {
          color: "#333", // x-axis labels
        },
        title: {
          display: !isSmall,
          color: "#333", // x-axis labels
          text: "Ημερομηνία",
        },
      },
    },
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "1rem",
        borderRadius: "8px",
        boxShadow: "0 4px 10px 0 rgba(0,0,0,0.2)",
      }}
    >
      <Line data={data} options={options} />
    </div>
  );
};

export default LineChart;
